module.exports = "/_next/static/images/60808f138efb76576d7e4bc9739478ec-young-people-walking@2x.jpg.webp";